import styled from 'styled-components';
import {
  compose,
  shadow,
  ShadowProps,
  color,
  BackgroundColorProps,
  typography,
  TypographyProps,
  space,
  SpaceProps
} from 'styled-system';

export interface IStyledSearchList extends SpaceProps, ShadowProps {
  /**
   * Input error state
   */
  hasError?: boolean;
}
export interface IStyledSearchBoxProps
  extends TypographyProps,
    SpaceProps,
    BackgroundColorProps {}
export interface IStyledSearchOption extends SpaceProps {
  /**
   * This prop sets the overflown text to use ellipsis.
   * When the SearchList enables scrolling option with prop searchListRows,
   * this option should be used.
   */
  ellipsis?: boolean;
  /**
   * Input error state
   */
  hasError?: boolean;
}

export const StyledSearchBox = styled.div<IStyledSearchBoxProps>`
  position: relative;
  width: 100%;

  ${compose(color, typography, space)}
`;

export const StyledSearchList = styled.ul<IStyledSearchList>`
  background-color: ${({ theme }) => theme.colors.grayScale[0]};
  border-bottom: 1px solid
    ${({ hasError, theme }) =>
      hasError
        ? theme.colors.state.danger
        : theme.colors.form.input.border.focus};
  list-style: none;
  margin: 0;
  padding: 0;
  position: absolute;
  width: 100%;
  z-index: ${({ theme }) => theme.zIndices[3]};
  ${compose(space, shadow)};
`;
export const StyledSearchOption = styled.li<IStyledSearchOption>`
  ${({ theme, ellipsis }) => `
    color: ${theme.colors.form.text.menu.enabled};
    width: 100%;
    overflow-wrap: break-word;
    &:hover {
      cursor: pointer;
      background-color: ${theme.colors.background.hover};
      color: ${theme.colors.form.text.menu.hover};
    }
    &[aria-selected='true'] {
      outline: 1px solid ${theme.colors.form.input.border.focus};
      background-color: ${theme.colors.background.hover};
      color: ${theme.colors.form.text.menu.hover};
    }

    ${
      ellipsis
        ? `
      white-space: nowrap;
      overflow-x: hidden;
      text-overflow: ellipsis;
    `
        : ''
    }
  `}

  ${compose(space, color)}
`;

export const StyledSearchListFooter = styled.li<IStyledSearchOption>`
  ${({ theme, hasError }) => `
    border-top: 1px solid
      ${
        hasError
          ? theme.colors.state.danger
          : theme.colors.form.input.border.focus
      };
    width: 100%;
    color: ${theme.colors.form.text.input.enabled};
    padding: ${theme.space[2]}px;
  `}
  ${compose(space, color)}
`;
